//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import portal from '~/net/portal'
export default {
    name: 'Newscatagory',
    head() {
        return {
            title: this.newsType + '-江苏技术产权交易市场'
        }
    },
    data() {
        return {
            page: {
                type: 0,
                page: 1,
                rows: 15
            },
            newsList: []
        }
    },
    computed: {
        routes() {
            return [{ name: '首页', path: '/' }, { name: '资讯', path: '/news' }, { name: this.newsType }]
        }
    },
    async asyncData({ app, query, error, req }) {
        const [resp0, resp1] = await Promise.all(
            [
                app.$api.getPageInformation({
                    type: query.id,
                    rows: 15,
                    page: 1
                }),
                app.$api.getInformationType({
                    typeId: query.id
                })
            ].map(p => p.catch(e => e))
        ).catch(e => console.log(e))
        return {
            newsList: resp0?.data?.rows || [],
            total: resp0?.data?.total || 0,
            newsType: resp1?.data
        }
    },
    created() {
        this.page.type = this.$route.query.id
    },
    watchQuery: true,
    methods: {
        change(page) {
            this.page.page = page
            this.getPageInformation()
        },
        getPageInformation() {
            this.$api.getPageInformation(this.page).then(res => {
                const { code, data, message } = res
                if (code === '0000') {
                    this.newsList = data.rows
                    this.total = data.total
                }
            })
        }
    }
}
